import React from "react";

const PrivateData = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5006 20.9993H7.00058C6.47015 20.9993 5.96144 20.7886 5.58637 20.4135C5.21129 20.0384 5.00058 19.5297 5.00058 18.9993V12.9993C5.00058 12.4688 5.21129 11.9601 5.58637 11.5851C5.96144 11.21 6.47015 10.9993 7.00058 10.9993H17.0006C17.531 10.9993 18.0397 11.21 18.4148 11.5851C18.7899 11.9601 19.0006 12.4688 19.0006 12.9993V13.4993"
      stroke="#6F43E7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0002 15.9998C11.0002 16.265 11.1056 16.5193 11.2931 16.7069C11.4806 16.8944 11.735 16.9998 12.0002 16.9998C12.2654 16.9998 12.5198 16.8944 12.7073 16.7069C12.8949 16.5193 13.0002 16.265 13.0002 15.9998C13.0002 15.7345 12.8949 15.4802 12.7073 15.2926C12.5198 15.1051 12.2654 14.9998 12.0002 14.9998C11.735 14.9998 11.4806 15.1051 11.2931 15.2926C11.1056 15.4802 11.0002 15.7345 11.0002 15.9998Z"
      stroke="#6F43E7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00052 10.9995V6.99951C8.00052 5.93865 8.42195 4.92123 9.17209 4.17108C9.92224 3.42094 10.9397 2.99951 12.0005 2.99951C13.0614 2.99951 14.0788 3.42094 14.8289 4.17108C15.5791 4.92123 16.0005 5.93865 16.0005 6.99951V10.9995"
      stroke="#6F43E7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0003 18.9995L17.0003 20.9995L21.0003 16.9995"
      stroke="#6F43E7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PrivateData;
